export const BaseChar = {
  'number': [
    '0', '1', '2', '3', '4', '5', '6', '7', '8', '9',
  ],
  'lowerCase': [
    'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z',
  ],
  'upperCase': [
    'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z',
  ],
  'other': [
    '*', '+', '-', '<', '=', '>', '(', ')', '[', ']', '{', '}', '|', '!', '$', '%', ':', ';', '@', '^', '_', '~',
  ],
};

// 包含全部数字, 小写字母, 大写字母的字符集合
export const NUMBER_LOWER_UPPER = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
// 包含全部数字, 小写字母的字符集合
export const NUMBER_LOWER = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z'];
// 包含全部数字, 大写字母的字符集合
export const NUMBER_UPPER = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
// 包含全部小写字母, 大写字母的字符集合
export const LOWER_UPPER = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];

/**
 * 数字转字符, 进制转换
 * @param value 要转换的数组
 * @param base  转换结果中允许包含的字符(默认包含全部的数字,小写字母, 大写字母)
 */
function scaleTransition(
  value: number | bigint,
  base = NUMBER_LOWER_UPPER,
): string {
  if (value < 0) {
    throw new Error('scaleTransition Error, value < 0');
  }
  if (value === 0) {
    return base[0];
  }
  if (typeof value === 'bigint') {
    const radix = BigInt(base.length);
    let result = '';
    let resValue = value;
    while (resValue > 0) {
      result = base[Number(resValue % radix)] + result;
      resValue /= radix;
    }
    return result;
  } else {
    const radix = base.length;
    let result = '';
    let resValue = value;
    while (resValue > 0) {
      result = base[resValue % radix] + result;
      resValue = Math.floor(resValue / radix);
    }
    return result;
  }
}

export { scaleTransition };
export default scaleTransition;
